import {
    ForgotPassword,
    ForgotPasswordDescription,
    ForgotPasswordInput,
    ForgotPasswordTitle,
    ForgotPasswordTitleDescWrapper,
    SubmitButton
} from "@/components/Auth/ForgotPasswordModal/ForgotPasswordModal.styled";
import {useTranslations} from "next-intl";
import useFormSuccessMutation from "@/hooks/useFormSuccessMutation";
import {authApi} from "@/store/api/v1/auth";
import {useModal} from "@/hooks/useModal";
import messageService from "@/services/messageService";
import useFormErrorMutation from "@/hooks/useFormErrorMutation";
import ForgotPasswordFormAction from "@/components/Auth/ForgotPasswordModal/ForgotPasswordFormAction";


const ForgotPasswordModal = () => {
    const t = useTranslations('Auth.SignUpForm.ForgotPassword')
    const tp = useTranslations('Placeholders')
    const tm = useTranslations('Main.Buttons')
    const forgotPassword = useModal('forgot-password')

    useFormSuccessMutation([authApi, 'forgotPassword'], (data) => {
       forgotPassword.hide()

        messageService.success({
            content: data.message,
            duration: 5,
        });
    }, [])

    useFormErrorMutation([authApi, 'forgotPassword'], () => {
        forgotPassword.hide()
    }, [])

    return (
        <ForgotPassword name={'forgot-password'}>
            <ForgotPasswordTitleDescWrapper>
                <ForgotPasswordTitle>
                    {t('title')}
                </ForgotPasswordTitle>
                <ForgotPasswordDescription>
                    {t('text')}
                </ForgotPasswordDescription>
            </ForgotPasswordTitleDescWrapper>
            <ForgotPasswordFormAction>
                <ForgotPasswordInput name={'email'} label={tp('enter_your_email')}/>
                <SubmitButton type={'submit'}>{tm('submit')}</SubmitButton>
            </ForgotPasswordFormAction>
        </ForgotPassword>
    );
};

export default ForgotPasswordModal;